import {
  BatchOrderAcceptBreakingNewsConditionListItem,
  BatchOrderAcceptBreakingNewsConditionListItemFromJSON
} from '@/api/models/batch/BatchOrderAcceptBreakingNewsConditionListItem'

export interface BatchOrderAcceptBreakingNewsPageLoadResult {
  items: BatchOrderAcceptBreakingNewsConditionListItem
}

export function BatchOrderAcceptBreakingNewsPageLoadResultFromJSON(
  json: any
): BatchOrderAcceptBreakingNewsPageLoadResult {
  return {
    items: BatchOrderAcceptBreakingNewsConditionListItemFromJSON(json)
  }
}
